export default __webpack_public_path__ + "static/media/accessories.64baed61.png";